var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderopen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9876 9.60191L14.6985 13.1072C14.5901 14.1798 14.5034 15 12.5448 15H3.45313C1.49458 15 1.40785 14.1798 1.29945 13.1072L1.01036 9.60191C0.952544 9.02003 1.14045 8.48022 1.48012 8.0666C1.48735 8.05959 1.48735 8.05959 1.49458 8.05258C1.89207 7.58288 2.49192 7.28844 3.16404 7.28844H12.8339C13.506 7.28844 14.0987 7.58288 14.4889 8.03856C14.4962 8.04557 14.5034 8.05258 14.5034 8.05959C14.8575 8.47321 15.0526 9.01302 14.9876 9.60191Z",
    stroke: "#505F7B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85596 7.58988V3.97947C1.85596 1.59589 2.47026 1 4.92748 1H5.84532C6.76317 1 6.97275 1.2664 7.31966 1.71507L8.2375 2.90686C8.46877 3.2013 8.60608 3.38358 9.22039 3.38358H11.0633C13.5205 3.38358 14.1348 3.97947 14.1348 6.36304V7.61793",
    stroke: "#505F7B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1416 11.4948H9.85634",
    stroke: "#505F7B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderopen);
export default __webpack_public_path__ + "static/media/folderopen.b3327303.svg";
export { ForwardRef as ReactComponent };